export class ModuleConfiguration {
  static moduleName = 'dynamicDataSet';
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/dynamicDataSet.module.config.ts